export const Privacy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-navy-950 text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold">Privacy Policy</h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose max-w-none">
            <p className="text-sm text-gray-500 mb-8">Last Updated: December 2024</p>

            <div className="space-y-8 text-gray-600 leading-relaxed">
              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">1. Introduction</h2>
                <p>
                  VERLINE ("we," "our," or "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect information when you visit our website or engage with us for business purposes.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">2. Information We Collect</h2>
                <p className="mb-3">
                  We collect information you provide directly when contacting us for business purposes:
                </p>
                <ul className="list-disc ml-6 space-y-2">
                  <li>Name and contact information (email, phone)</li>
                  <li>Company name and business information</li>
                  <li>Message content and inquiry details</li>
                  <li>Any additional information you choose to provide</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">3. How We Use Information</h2>
                <p className="mb-3">
                  We use collected information exclusively for business purposes:
                </p>
                <ul className="list-disc ml-6 space-y-2">
                  <li>Responding to partnership and business inquiries</li>
                  <li>Evaluating potential business relationships</li>
                  <li>Communicating about our services and capabilities</li>
                  <li>Maintaining records of business communications</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">4. Information Sharing</h2>
                <p>
                  We do not sell, rent, or share your personal information with third parties except as necessary to conduct business operations or as required by law. We may share information with service providers who assist with our business operations under strict confidentiality agreements.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">5. Data Security</h2>
                <p>
                  We implement reasonable security measures to protect information from unauthorized access, alteration, or destruction. However, no internet transmission is completely secure, and we cannot guarantee absolute security.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">6. Consumer Privacy</h2>
                <p>
                  This website is for business partnership information only. Consumer transactions occur through marketplace platforms (Amazon, Walmart, eBay, etc.), and those platforms' privacy policies govern consumer data. We do not collect consumer data through this website.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">7. Your Rights</h2>
                <p className="mb-3">
                  You have the right to:
                </p>
                <ul className="list-disc ml-6 space-y-2">
                  <li>Request access to your personal information</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your information</li>
                  <li>Opt out of future communications</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">8. Cookies and Tracking</h2>
                <p>
                  Our website may use basic cookies for functionality purposes. We do not use tracking cookies for advertising or analytics. You can disable cookies in your browser settings.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">9. Changes to Privacy Policy</h2>
                <p>
                  We may update this Privacy Policy periodically. Changes will be posted on this page with an updated "Last Updated" date.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-navy-900 mb-4">10. Contact Us</h2>
                <p>
                  For privacy-related questions or to exercise your privacy rights, contact us at partnerships@verline.com.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
